import React from 'react';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
import { TableCell, Typography, TableContainer, Table, TableHead, TableRow, TableBody, Grid, Stack, Button, TextField } from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';
import Swal from 'sweetalert2';

import { API } from 'aws-amplify';

import ErrorView from '../error';
import { open, close } from '../../features/loading/loadingSlice';
import { change, back, next, reset } from '../../features/entry/entrySlice';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.common.black,
    fontSize: 30,
    fontWeight: 800,
    width: 24,
    border: '1px solid',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    height: 24,
    border: '1px solid',
    padding: 8,
  },
}));

const BingoMassCell = (bingo_massCellProps) => {
  return (
    <StyledTableCell align='center'>
      <TextField variant='standard' InputProps={{ sx: { '& input': { textAlign: 'center' } }, }} {...bingo_massCellProps} />
    </StyledTableCell>
  );
};

const BingoCard = (props) => {
  const bingoCardCellOnBlur = () => {
    let bingo_massError = '';
    let allNumber = [];
    for (let i = 0; i < 5; i++) {
      for (let j = 0; j < 5; j++) {
        let number = props.entry.bingo_mass[i][j];
        if (number !== '') {
          if (!(/^([1-9]\d*|0|)$/.test(number)) || parseInt(number) > 99 || parseInt(number) === 0) {
            bingo_massError = '1から99までの数字のみ入力可能';
            break;
          }
          if (allNumber.includes(number)) {
            bingo_massError = '番号の重複は不可';
            break;
          } else {
            allNumber.push(number);
          }
        }
      }
      if (bingo_massError !== '') {
        break;
      }
    }
    props.change({ name: 'bingo_massError', value: bingo_massError })
  }

  return (
    <>
      <Typography variant='h7' margin='normal'>ビンゴカードの記入</Typography>
      <TableContainer margin='normal' sx={{ textAlign: 'center' }}>
        <Table sx={{ width: 200, display: 'initial' }} aria-label='customized table'>
          <TableHead>
            <TableRow>
              <StyledTableCell align='center'>B</StyledTableCell>
              <StyledTableCell align='center'>I</StyledTableCell>
              <StyledTableCell align='center'>N</StyledTableCell>
              <StyledTableCell align='center'>G</StyledTableCell>
              <StyledTableCell align='center'>O</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.entry.bingo_mass.map((bingo_massRow, i) => {
              return (<TableRow key={`bingo_massRow${i}`}>
                {bingo_massRow.map((value, j) => {
                  return (<BingoMassCell key={`bingo_massCell${i}${j}`} name={`bingo_massCell_${i}_${j}`} value={value} onBlur={bingoCardCellOnBlur}
                    onChange={(event) => { props.change({ bingo_massRowIndex: i, bingo_massCellIndex: j, name: event.target.name, value: event.target.value }) }} />);
                })}
              </TableRow>);
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant='overline' color='error'>{props.entry.bingo_massError}</Typography>
    </>
  );
}

const Step2 = (props) => {
  const submitDisabled = props.entry.bingo_mass[0].includes('') || props.entry.bingo_mass[1].includes('')
    || props.entry.bingo_mass[2].includes('') || props.entry.bingo_mass[3].includes('')
    || props.entry.bingo_mass[4].includes('') || !!props.entry.bingo_massError;

  const send = () => {
    let data = { body: { operation: 'entry', ...props.entry, } };
    props.open();
    API.post('uabingoapi', '/entry', data)
      .then(response => {
        props.close();
        Swal.fire({
          title: 'エントリーの受付が完了しました',
          icon: 'success',
          html: '<p>本イベントのエントリーが完了しました。<br>ご参加ありがとうございます。</p>',
          confirmButtonColor: '#33ab9f',
        }).then(() => {
          props.reset();
        });
      })
      .catch(error => {
        props.close();
        ErrorView(error.response.data.message);
      });
  }

  return (
    <Grid container>
      <Grid item xs={12} justifyContent='center' p={2}>
        <BingoCard {...props} />
      </Grid>
      <Grid item xs={6}>
        <Button variant='contained' color='primary' onClick={() => { props.back(props.entry.activeStep) }}>前へ</Button>
      </Grid>
      <Grid item xs={6}>
        <Stack direction='row' spacing={2} justifyContent='flex-end'>
          <Button variant='contained' color='primary' onClick={() => { props.reset() }}>リセット</Button>
          <Button disabled={submitDisabled} variant='contained' color='primary' onClick={send}>送信</Button>
        </Stack>
      </Grid>
    </Grid>
  );
}

/** react-redux */
const mapStateToProps = (state) => {
  return {
    entry: state.entry,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    open: () => dispatch(open()),
    close: () => dispatch(close()),
    change: (...args) => dispatch(change(...args)),
    back: (activeStep) => dispatch(back(activeStep)),
    next: (activeStep) => dispatch(next(activeStep)),
    reset: () => dispatch(reset()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Step2);